import React from "react";
import OTLayout from "./OTLayout";
import { LIVE_CASES, CASE_PHASES } from "./mockData";
import {
  OtPage,
  SectionCard,
  OtProgressBar,
  Box,
  Grid,
  Typography,
  Stack,
  Chip,
  eyebrowSx,
  titleSx,
  subtitleSx,
} from "./ui";
import { C } from "./constants";

export default function OTCases() {
  return (
    <OTLayout activeNav="cases">
      <OtPage>
        <Typography sx={eyebrowSx}>Real-time</Typography>
        <Typography component="h1" sx={titleSx}>Live OT cases</Typography>
        <Typography sx={{ ...subtitleSx, mb: 3 }}>Phase tracking across every running theatre.</Typography>

        <Grid container spacing={2}>
          {LIVE_CASES.map((c) => {
            const phaseIdx = CASE_PHASES.indexOf(c.phase);
            const pct = ((phaseIdx + 1) / CASE_PHASES.length) * 100;
            const isRunning = c.state === "running";

            return (
              <Grid item xs={12} md={6} key={c.ot}>
                <SectionCard sx={{ p: 2.5 }}>
                  <Stack direction="row" justifyContent="space-between" spacing={1.5}>
                    <Box>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Chip
                          label={c.ot}
                          size="small"
                          sx={{
                            height: "auto",
                            borderRadius: "6px",
                            fontSize: 11,
                            fontWeight: 700,
                            bgcolor: "#E9F5FE",
                            color: C.primary,
                            "& .MuiChip-label": { px: 1, py: 0.25 },
                          }}
                        />
                        <Chip
                          label={c.state}
                          size="small"
                          sx={{
                            height: "auto",
                            borderRadius: 999,
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: "uppercase",
                            bgcolor: isRunning ? "#d1f2db" : "#e0e7ff",
                            color: isRunning ? C.success : "#4338ca",
                            "& .MuiChip-label": { px: 1, py: 0.25 },
                          }}
                        />
                      </Stack>
                      <Typography component="h3" sx={{ mt: 1.25, fontSize: 16, fontWeight: 700 }}>{c.procedure}</Typography>
                      <Typography sx={{ mt: 0.5, fontSize: 12, color: C.textSub }}>{c.patient}</Typography>
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      <Typography sx={{ fontSize: 12, color: C.textSub }}>{c.elapsed}</Typography>
                      <Typography sx={{ mt: 0.5, fontSize: 12, color: C.textSub }}>Swabs {c.swabs}</Typography>
                    </Box>
                  </Stack>

                  <Box sx={{ mt: 2 }}>
                    <Stack direction="row" justifyContent="space-between" sx={{ fontSize: 12 }}>
                      <Typography sx={{ fontWeight: 600, fontSize: 12 }}>{c.phase}</Typography>
                      <Typography sx={{ fontSize: 12, color: C.textSub }}>{phaseIdx + 1} / {CASE_PHASES.length}</Typography>
                    </Stack>
                    <OtProgressBar value={pct} phases={CASE_PHASES} activeIndex={phaseIdx} />
                  </Box>

                  <Stack
                    component="footer"
                    direction="row"
                    justifyContent="space-between"
                    sx={{ mt: 2, pt: 1.5, borderTop: `1px solid ${C.border}`, fontSize: 12, color: C.textSub }}
                  >
                    <Typography sx={{ fontSize: 12, color: C.textSub }}>
                      Surgeon: <Box component="span" sx={{ color: C.text, fontWeight: 700 }}>{c.surgeon}</Box>
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: C.textSub }}>
                      Anaesthesia: <Box component="span" sx={{ color: C.text, fontWeight: 700 }}>{c.anaes}</Box>
                    </Typography>
                  </Stack>
                </SectionCard>
              </Grid>
            );
          })}
        </Grid>
      </OtPage>
    </OTLayout>
  );
}
